import { API } from "../store"
import handleCatch from "../lib/catch"

export const setGigs = (gigs = []) => ({
  type: "GIG::SET_GIGS",
  data: gigs.gigs && gigs.gigs.length > 0 ? gigs.gigs : [],
})

export const setsearchedGigs = (gigs = []) => ({
  type: "GIG::SET_GIGS",
  data: gigs,
})

export const toggleConfirmGigApplyDialog = data => ({
  type: "GIG::TOGGLE_CONFIRM_GIG_APPLY_DIALOG",
  data,
})

export const toggleConfirmSocialIntegrationDialog = data => ({
  type: "GIG::TOGGLE_CONFIRM_SOCIAL_INTEGRATION_DIALOG",
  data,
})

export const toggleGigDialog = data => {
  return {
    type: "GIG::TOGGLE_GIG_DIALOG",
    data: data.gig,
  }
}

export const getGigsList = () => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/gigs/listGigs`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }
            return response
          })
          .then(response => response.body)
          .then(data => {
            dispatch(setGigs(data))
            resolve(data)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const createGigApplication = newGigApplicationData => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/gigs/apply`)
          .send(newGigApplicationData)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(data => {
            resolve(data)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const removeGigApplicationById = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(`/gigs/${id}`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }
            return response
          })
          .then(response => response.body)
          .then(data => {
            resolve(data)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}
